/* global Stripe */

export const getCardType = val => Stripe.card.cardType(val)
